import * as Yup from "yup";

export const DepartmentMappingFormValidation = Yup.object({
    id: Yup.string()
        .required("External Code is required")
        .min(1)
        .max(50),
    sourceTypeId: Yup.string()
        .required("Source System is required"),
});
